import SvgIcon from "@/components/SvgIcon.vue"
export function setupSvgIcons(app) {
  const req = require.context('@/assets/icons', false, /\.svg$/)
    const requireAll = requireContext => requireContext.keys().map(requireContext)
    requireAll(req);
    app.component('svg-icon', SvgIcon);
  }